import * as React from 'react';
/**
 * When use this context. Will trade as sub component instead of root Steps component.
 */
export const InternalContext = /*#__PURE__*/React.createContext(null);